<template>
  <el-form-item :label="$t('필드')">
    <el-select v-model="orderListTableFields" multiple collapse-tags placeholder="필드를 선택하세요">
      <el-option v-for="item in fieldItems" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { ORDER_LIST_TABLE_FIELDS } from '@/utils/constants'

export default {
  name: 'TableFieldCombo',

  computed: {
    fieldItems() {
      return ORDER_LIST_TABLE_FIELDS.map((x) => ({
        label: this.$t(x.label),
        value: x.value,
      }))
    },

    orderListTableFields: {
      get() {
        return this.$store.getters['ui/orderListTableFields']
      },
      set(value) {
        this.$store.dispatch('ui/setOrderListTableFields', value)
      },
    },
  },
}
</script>
